// extracted by mini-css-extract-plugin
export default {"monthly-summary-box":"monthlySummary_monthly-summary-box__YYTRF","disabled":"monthlySummary_disabled__CfUWw","monthly-summary":"monthlySummary_monthly-summary__FrGVK"};